// e-mail
const EMAIL = new RegExp(
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

// Rfc RegExp
const RFC = new RegExp(
    /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/
);

const NEW_USER_RFC =
    /^[A-ZÑ&]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])(?:[A-Z\d]{3})$/;

const UPPERCASE = /^[^a-z]*$/;

const STANDARD_DATE_FORMAT = new RegExp(
    /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/
);

const USERNAME = new RegExp(/^[a-zÑ&A-Z0-9]{2,50}$/);

const PASSWORD = new RegExp(
    /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&*+\-<>])[a-zA-Z0-9@#$%&*+\-<>]{8,50}$/
);

export default {
    EMAIL,
    RFC,
    NEW_USER_RFC,
    UPPERCASE,
    STANDARD_DATE_FORMAT,
    USERNAME,
    PASSWORD,
};
